import useLazySnackbar from 'components/banners/useLazySnackbar';

export const useShowBannerOnAvailabilityToggle = () => {
  const { enqueueSnackbar } = useLazySnackbar();

  return (active: boolean) => {
    enqueueSnackbar(active ? 'Your boat has been set to active.' : 'Your boat has been set to inactive.', {
      variant: 'success',
      autoHideDuration: 5000,
    });
  };
};
